import { Component } from '@angular/core';
import { ModalComponent } from '../../modal-service/modal.service';
import { ProductsNotesModel } from '../models/products-notes-model';
import { Constants } from '../../../core/Constants';

@Component({
  selector: 'app-product-notes-form',
  templateUrl: './product-notes-form.component.html',
  styleUrls: ['./product-notes-form.component.css']
})
export class ProductNotesFormComponent extends ModalComponent<ProductsNotesModel[]> {
  data: ProductsNotesModel[] = null;

  initForm(arg: ProductsNotesModel[]) {
    this.data = arg;
  }

  getKeyFromType(type: string) {
    switch (type) {
      case Constants.LABOUR_TYPE_STUDDING:
          return 'FC.ProductNotesForm.Studding';
      case Constants.LABOUR_TYPE_MOUNTING_AND_BALANCING:
          return 'FC.ProductNotesForm.MountingAndBalancing';
      default:
          return 'N/A';
    }
  }
}
